export const multiselect = {
  colorScheme: {
    filledBackground: '#333643',
    filledHoverBackground: '#333643',

    dropdown: {
      color: '{neutral.400}',
    },
    light: {
      filledBackground: '#333643',
      filledHoverBackground: '#333643',
      // background: '{surface.100}',
      color: '{neutral.900}',
      borderColor: '{surface.600}',
      placeholderColor: '{inputtext.placeholder.color}',
      disabled: {
        background: '{inputtext.disabled.background}',
        color: '{inputtext.disabled.color}',
      },
      root: { color: 'black' },
      optionGroup: {
        color: 'black',
      },
    },
    dark: {
      background: '{form.field.background}',
      color: 'white',
      borderColor: '#5B5F69',
      placeholderColor: '{inputtext.placeholder.color}',
      option: {
        // background: '#333643',
        color: '{text.color}',
        focus: {
          background: '#555B6E',
          color: 'white',
        },
        selected: {
          color: 'white',
          focus: {
            color: 'white',
          },
        },
      },
      overlay: {
        background: '#333643',
        color: 'white',
        borderColor: '#5B5F69',
        list: 'white',
      },
      list: {
        background: '#333643',
      },
      optionGroup: {
        background: '#333643',
        color: 'white',
      },
      root: { color: 'white' },
      disabled: {
        background: '{inputtext.disabled.background}',
        color: '{inputtext.disabled.color}',
      },
    },
  },
};
